"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDistributorFlashOrder = void 0;
var post_distributor_flash_order_1 = require("./post-distributor-flash-order");
Object.defineProperty(exports, "postDistributorFlashOrder", { enumerable: true, get: function () { return post_distributor_flash_order_1.postDistributorFlashOrder; } });
